import {API} from 'aws-amplify'

export default class ReadDB{
    readLink(link){
        return new Promise((resolve,reject)=>{
            const init = {
                headers: {'Content-type': 'application/json'},
            }

            API.get('Patient','/read?link=' + link + '&type=link',init).then(response =>{
               resolve(response)
            });
        })
    }
}